    document.addEventListener('click', function() {
        // Replace 'variant-selector-id' with the actual ID of your variant selector
        var variantSelector = document.getElementById('Option-template--20573861544085__main-0')
            if (variantSelector) {
                const myShirtSize = document.getElementById('shirtSize');
                const myShirtColor = document.getElementById('shirtColor');
                const myDesignNumber = document.getElementById('designNumber');
                var selectedVariantId = variantSelector.value;
            variantSelector.addEventListener('change', function() {
                // This function will execute when the variant selection changes
                selectedVariantId = this.value; // Get the ID of the newly selected variant
                if(selectedVariantId == "Bag") {
                // add the "hidden" class
                myShirtSize.classList.add('hidden');
                myShirtColor.classList.add('hidden');
                myDesignNumber.classList.add('hidden');
            }else{
                // Remove the "hidden" class
                myShirtSize.classList.remove('hidden');
                myShirtColor.classList.remove('hidden');
                myDesignNumber.classList.remove('hidden');
            }

            });
            if(selectedVariantId == "Bag") {
                // add the "hidden" class
                myShirtSize.classList.add('hidden');
                myShirtColor.classList.add('hidden');
                myDesignNumber.classList.add('hidden');
                document.getElementById('my-custom-dropdown1').selectedIndex = 0;
                document.getElementById('my-custom-dropdown2').selectedIndex = 0;
                document.getElementById('my-custom-dropdown3').selectedIndex = 0;
            }else{
                // Remove the "hidden" class
                myShirtSize.classList.remove('hidden');
                myShirtColor.classList.remove('hidden');
                myDesignNumber.classList.remove('hidden');
            }

        }
/* Replace 'variant-selector-id' with the actual ID of your variant selector
        var variantSelector2 = document.getElementById('Option-template--20573861576853__main-0')
            if (variantSelector2) {
                const myShirtSize = document.getElementById('shirtSize');
                const myShirtSizePlus = document.getElementById('shirtSizePlus');
                const myYouthShirtSize = document.getElementById('youthShirtSize');
                myShirtSizePlus.classList.add('hidden');               
                myYouthShirtSize.classList.add('hidden');                
                var selectedVariantId = variantSelector2.value;
            variantSelector2.addEventListener('change', function() {
                // This function will execute when the variant selection changes
                selectedVariantId = this.value; // Get the ID of the newly selected variant
            if(selectedVariantId == "Tee Shirt (2XL-3XL-4XL)") {
                 // Remove the "hidden" class from plus size               
                myShirtSizePlus.classList.remove('hidden');
                myShirtSize.classList.add('hidden');
                myYouthShirtSize.classList.add('hidden');                    
            } else if(selectedVariantId == "Youth Tee Shirt (4T-YS-YM-YL-YXL)") {
                // Remove the "hidden" class from youth size
                myYouthShirtSize.classList.remove('hidden');
                myShirtSize.classList.add('hidden');
                myShirtSizePlus.classList.add('hidden');
            }else{
                // Remove the "hidden" class from regular size
                myShirtSize.classList.remove('hidden');
                myShirtSizePlus.classList.add('hidden');               
                myYouthShirtSize.classList.add('hidden');
            }

            });
            if(selectedVariantId == "Tee Shirt (2XL-3XL-4XL)") {
                 // Remove the "hidden" class from plus size               
                myShirtSizePlus.classList.remove('hidden');
                myShirtSize.classList.add('hidden');
                myYouthShirtSize.classList.add('hidden');      
                document.getElementById('my-custom-dropdown1').selectedIndex = 0;
                document.getElementById('my-custom-dropdown2').selectedIndex = 0;
                document.getElementById('my-custom-dropdown3').selectedIndex = 0;
                document.getElementById('my-custom-dropdown4').selectedIndex = 0;
                document.getElementById('my-custom-dropdown5').selectedIndex = 0;
            } else if(selectedVariantId == "Youth Tee Shirt (4T-YS-YM-YL-YXL)") {
                // Remove the "hidden" class from youth size
                myYouthShirtSize.classList.remove('hidden');
                myShirtSize.classList.add('hidden');
                myShirtSizePlus.classList.add('hidden');
            }else{
                // Remove the "hidden" class from regular size
                myShirtSize.classList.remove('hidden');
                myShirtSizePlus.classList.add('hidden');               
                myYouthShirtSize.classList.add('hidden');
            }

        }
        */
    });